import type { CountryCode } from 'libphonenumber-js/max'
import { isValidPhoneNumber as isValidPhoneNumberCore } from 'libphonenumber-js/max'
import isEmpty from 'lodash/isEmpty'

export * from '../is-valid-email'

export const isValidNumber = (value: any) => {
  //check of the common number proeprties
  if (value === Number.MIN_VALUE || value === Number.MAX_VALUE || value === Number.EPSILON) return true

  return /^-?\d*\.?\d*$/.test(value)
}

export const isValidPhoneNumber = (value: string, countryCode: CountryCode = 'US'): boolean => {
  //trim first the value
  value = value?.trim?.()

  //always return as true if the value of string is empty/null/undefined
  if (isEmpty(value)) return true

  return isValidPhoneNumberCore(value, countryCode)
}

export const validatePhoneNumber = (value: string, countryCode: CountryCode = 'US') => {
  if (!isValidPhoneNumber(value, countryCode)) {
    throw new Error(
      `Invalid phone number format. You might want to include the country code and leading ' + ' sign and make sure the length are correct.`
    )
  }
}
